import WarehouseAdminOptionData, {
    IWarehouseAdminOptionData
} from "@/http/data/warehouse-admin-option-data";

export interface IWarehouseAdminOptionsData {
    categories?: IWarehouseAdminOptionData[];
    types?: IWarehouseAdminOptionData[];
    warehouses?: IWarehouseAdminOptionData[];
    buildings?: IWarehouseAdminOptionData[];
    suppliers?: IWarehouseAdminOptionData[];
}

export default class WarehouseAdminOptionsData {
    public categories: WarehouseAdminOptionData[];
    public types: WarehouseAdminOptionData[];
    public warehouses: WarehouseAdminOptionData[];
    public buildings: WarehouseAdminOptionData[];
    public suppliers: WarehouseAdminOptionData[];

    constructor(data: IWarehouseAdminOptionsData) {
        this.categories = (data.categories ?? []).map(item => new WarehouseAdminOptionData(item));
        this.types = (data.types ?? []).map(item => new WarehouseAdminOptionData(item));
        this.warehouses = (data.warehouses ?? []).map(item => new WarehouseAdminOptionData(item));
        this.buildings = (data.buildings ?? []).map(item => new WarehouseAdminOptionData(item));
        this.suppliers = (data.suppliers ?? []).map(item => new WarehouseAdminOptionData(item));
    }
}